<div class="row" [style.margin-top.px]="margin$ | async">
  <div class="columns">
    <div class="mos-u-shadow-depth-2 mos-u-spacer--margin-bottom-xxlg">
      <div *ngIf="header" class="row">
        <div class="columns">
          <div class="dsp-filters-row dsp-page-level-filters"
            [ngClass]="!(isMobile$ | async) ? 'dsp-content-filters-row' : 'dsp-mobile-filters-row'">
            <div *ngFor="let filter of filters; let index = index"
              [ngClass]="{ 'dsp-first-filter': index === 0, 'dsp-remaining-filters': index > 0 }">
              <ng-template [ngTemplateOutlet]="filter"></ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="columns">
          <div class="dsp-content-container mos-u-spacer--padding-md dsp-admin-profile-container"
            [ngClass]="{ 'dsp-upper-border' : !header }">
            <ng-container *ngIf="loading">
              <div class="dsp-content-spinner-wrapper">
                <div class="dsp-content-spinner"></div>
              </div>
            </ng-container>
            <ng-container *ngIf="!loading">
              <ng-content select="[dsp-content]"></ng-content>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>